import React from "react"

import HeadingDeprecated from "../../../../design-system/heading-deprecated"
import Stack from "../../../../design-system/stack"
import useBreakpoint from "../../../../utils/hooks/use-breakpoint"
import * as styles from "./index.module.scss"

type Props = {
  texts: { title?: string; details?: string }[]
}

function CaseStudyHighlights({ texts }: Props) {
  const { isXSmallBreakpoint, isMediumBreakpoint } = useBreakpoint()

  return (
    <div className={styles.container}>
      <Stack
        spacing={40}
        direction={!isXSmallBreakpoint && isMediumBreakpoint ? "row" : "column"}
      >
        {texts
          .filter(({ title }) => !!title)
          .map(({ title, details }) => (
            <div key={title} className={styles.highlight}>
              {details ? (
                <>
                  <HeadingDeprecated variant="h4" className={styles.bigHeading}>
                    {title}
                  </HeadingDeprecated>
                  <span className={styles.details}>{details}</span>
                </>
              ) : (
                <HeadingDeprecated variant="h4" className={styles.smallHeading}>
                  {title}
                </HeadingDeprecated>
              )}
            </div>
          ))}
      </Stack>
    </div>
  )
}

export default CaseStudyHighlights
